import React from 'react';
import '../styles/Research.css'; // Assuming you have a CSS file for styling
function Research() {
  const researchCategories = [
    {
      title: "Homogenization and Localization of Heterogeneous Materials",
      description: [
        "Homogenization involves the determination of macroscopic or homogenized (also called average or effective) response of a material/structural component with periodic microstructure, whereas localization refers to local stress recovery.",
        "0th-order homogenization and localization involve periodic materials subjected to macroscopically uniform loading. Such materials are comprised of many identical unit cells that are duplicated in all directions. Hence under macroscopically uniform loading the response of the entire array of repeating unit cells reduces to the determination of the response of a single unit cell under periodic boundary conditions.",
        "In contrast with 0th-order homogenization, asymptotic (also called higher-order) homogenization is employed to determine local stress fields in periodic materials subjected to macroscopically nonuniform loading."
      ],
      applications: [
        { name: "Thermal barrier coatings for aerospace/aircraft industry", link: "#" },
        { name: "Synthetic chordae tendineae for biomedical applications", link: "#" },
        { name: "Bonded laminated joints for aircraft industry", link: "#" },
        { name: "Damage evolution in laminated composites", link: "#" },
        { name: "Homogenization and localization of periodic unidirectional composites with regular and irregular fiber distributions in the elastic, viscoelastic and elastic-plastic domains", link: "#" },
        { name: "Nanoporous composites", link: "#" }
      ],
      methods: [
        {
          name: "FVDAM Method",
          description: "The acronym stands for Finite-Volume Direct Averaging Micromechanics, and the related Matlab-based codes generate average or homogenized elastic-plastic stress-strain response, and local stress fields, of a heterogeneous material with arbitrarily periodic microstructure under macroscopically uniform applied loading for any combination of macroscopic strains/stresses.",
          publicationsLink: "/publications/fvdam",
          demoLink: "/demos/fvdam"
        }
      ]
    },
    {
      title: "Example two ",
      description: [
        "This is example two description paragraph one.",
      ],
      applications: [
      ],
      methods: [

      ]
    }
  ];

  return (
    <div className="research-page">
      <div className="container">
        <section className="intro">
          <h1>EMC Research</h1>
          <p>Computational Algorithms for Advanced Materials and Structures</p>
          <p>We are developers of accurate, efficient, and easy-to-use computational algorithms for the response of advanced materials and structural components with both homogeneous and heterogeneous microstructures. The theories that underpin these algorithms are based on our own in-house approaches to the solution of material/structural boundary-value problems and are at least as competitive as the standard variational-based commercial packages.</p>
        </section>

        <section>
          <h2>Research Categories</h2>
          
          {researchCategories.map((category, index) => (
            <div key={index} className="research-category">
              <h3>{category.title}</h3>
              {category.description.map((paragraph, pIndex) => (
                <p key={pIndex}>{paragraph}</p>
              ))}
              
              <div className="applications">
                <h4>Applications:</h4>
                <ul className="application-list">
                  {category.applications.map((app, aIndex) => (
                    <li key={aIndex}>
                      {app.name} <a href={app.link}>(click here)</a>
                    </li>
                  ))}
                </ul>
              </div>
              
              {category.methods.map((method, mIndex) => (
                <div key={mIndex} className="research-methods">
                  <h4>{method.name}</h4>
                  <p>{method.description}</p>
                  
                  <a href={method.publicationsLink} className="btn publication-btn">View Publications</a>
                  <a href={method.demoLink} className="btn">Access Online Demo</a>
                </div>
              ))}
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}

export default Research;